import { render, staticRenderFns } from "./mobileindex.vue?vue&type=template&id=21009ef1&scoped=true"
import script from "./mobileindex.vue?vue&type=script&lang=js"
export * from "./mobileindex.vue?vue&type=script&lang=js"
import style0 from "./mobileindex.vue?vue&type=style&index=0&id=21009ef1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_24c34b177a67bdab664b1ded2c59e9ec/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21009ef1",
  null
  
)

export default component.exports